import axios from 'axios'

export default function awaitUpdate (vueInstance, reference) {
  vueInstance.$scrollToElement('.loading-panel')

  return new Promise((resolve) => {
    let result = null
    const check = async () => {
      try {
        result = await axios.get(`${process.env.VUE_APP_BACKEND_HOST}/donation/${reference}/status`)
      } catch (error) {
        vueInstance.paymentStore.setPaymentSuccess(false)
        vueInstance.paymentStore.setPaymentProcessing(true)
        vueInstance.paymentStore.setComplete(true)
        vueInstance.paymentStore.setPaymentResult(error.message)
        return resolve({ status: 'failed' })
      }

      if (result.data.status !== 'pending') {
        if (result.data.status === 'failed') {
          vueInstance.paymentStore.setPaymentSuccess(false)
          vueInstance.paymentStore.setPaymentProcessing(true)
          vueInstance.paymentStore.setComplete(true)
          vueInstance.paymentStore.setPaymentResult(result.data.details)
        }
        return resolve(result.data)
      } else {
        setTimeout(check, 500)
      }
    }
    check()
  })
}
